<template>

  <body>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
      <div @click="mixNav()" class="burgerHeader">
        <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
      </div>
      <div class="burgerBody">
        <nav>
          <ul class="topMenu">
            <li class="active">
              <router-link to="/index" target="_self">
                Home
              </router-link>
            </li>
            <li class="">
              <router-link to="/shop" target="_self">
                Shop
              </router-link>
            </li>
            <li class="">
              <router-link to="/user/account" target="_self">
                Account
              </router-link>
            </li>
            <li class="">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div class="burgerBot">
        <p>supremeaccess | Legal | Disclousure</p>
      </div>
    </div>
    <header class="landHeader">
      <div class="landHeaderSub">
        <div class="logoContainer">
          <a href="#"><img src="../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <!--<nav class="landHeadNav">
        <li>
          <a href="#" class="openSidebar"><img src="../../assets/images/icon-cart.svg" alt="" /></a>
        </li>
      </nav> -->
      </div>
    </header>
    <div class="mobileNavTop">
      <a @click="mixNav()" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
      <div class="logoContainerMobile">
        <a href="#"><img src="../../assets/images/logo-white.svg" alt="" /></a>
      </div>
      <a href="#" class="iconCartMobile openSidebar"><img src="../../assets/images/icon-cart.svg" alt="" /></a>
    </div>
    <section class="homeBot">
      <div class="homeBotBod">
        <div class="desktop flexMenu" style="margin-bottom: 120px;">
          <li class="active">
            <router-link to="/index">Home</router-link>
          </li>
          <li>
            <router-link to="/shop">Shop</router-link>
          </li>
          <li v-if="loggedIn">
            <router-link to="/user/account">Account</router-link>
          </li>
          <li v-if="!loggedIn">
            <router-link to="/login">Login</router-link>
          </li>
          <li>
            <router-link to="/how-it-works">How It Works</router-link>
          </li>
        </div>
        <div class="pageTitle">
          <h1>Home</h1>
        </div>
      </div>
    </section>
  </body>
</template>
<script>
  export default {
    data() {
      return {
        showNav: false
      }
    },
    methods: {
      mixNav() {
        this.showNav = !this.showNav
      }
    },
    computed: {
      loggedIn() {
        let loggedIn = localStorage.getItem('user')
        return loggedIn
      }
    }
  }
</script>
<style scoped>
router-link {

  -webkit-font-smoothing: antialiased;
  background-color: transparent;
  border-width: 0;
  box-sizing: border-box;
  cursor: pointer;
  font-family: Roboto,sans-serif;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -.9px;
  margin: 0;
  outline: none;
  padding: 0;
  text-decoration: none;
  text-rendering: optimizelegibility;
  vertical-align: baseline;
}
a {
  -webkit-font-smoothing: antialiased;
  background-color: transparent;
  border-width: 0;
  box-sizing: border-box;
  cursor: pointer;
  font-family: Roboto,sans-serif;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -.9px;
  margin: 0;
  outline: none;
  padding: 0;
  text-decoration: none;
  text-rendering: optimizelegibility;
  vertical-align: baseline;
}
</style>
